import React, { useState, useEffect } from "react";
import { Modal, Button, Row, Col, Container, InputGroup, FormControl } from "react-bootstrap";
import axios from "axios";

const DoctorCard = ({ doctor, onClick }) => (
  <div className="modern-doctor-card-wrapper" onClick={() => onClick(doctor.id)}>
    <div className="modern-doctor-card">
      <div className="doctor-avatar-wrapper">
        <img
          src={doctor.picture || "https://img.freepik.com/free-vector/blue-circle-with-white-user_78370-4707.jpg"}
          alt={doctor.name}
          className="doctor-avatar-modern"
        />
      </div>
      <div className="doctor-info">
        <h5 className="doctor-name-modern">{doctor.name}</h5>
        <p className="doctor-spec">{doctor.specialization || "General Physician"}</p>
        <Button className="doctor-btn">View Profile</Button>
      </div>
    </div>
  </div>
);

const DoctorDetailsModal = ({ show, onHide, doctorId }) => {
  const [doctorDetails, setDoctorDetails] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (doctorId && show) {
      setLoading(true);
      axios
        .get(`https://ricgop.online/api/get-doctor-details.php?id=${doctorId}`)
        .then((res) => {
          setDoctorDetails(res.data);
          setLoading(false);
        })
        .catch(() => {
          setDoctorDetails(null);
          setLoading(false);
        });
    }
  }, [doctorId, show]);

  return (
    <Modal show={show} onHide={onHide} centered className="glass-modal">
  <Modal.Header closeButton>
    <Modal.Title>{doctorDetails ? doctorDetails.name : "Loading..."}</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    {loading && <p className="text-center">Loading details...</p>}
    {!loading && doctorDetails && (
      <Row className="align-items-center text-center text-md-start">
        <Col md={5} className="mb-3">
          <img
            src={doctorDetails.picture || "https://img.freepik.com/free-vector/blue-circle-with-white-user_78370-4707.jpg"}
            alt={doctorDetails.name}
            className="img-fluid doctor-modal-avatar"
          />
          <h5 className="mt-3">{doctorDetails.name}</h5>
          <p style={{ color: "#555" }}>{doctorDetails.specialization}</p>
        </Col>
        <Col md={7}>
          <h5>Experience</h5>
          <p>{doctorDetails.experience || "Not provided"}</p>
          <h5>Contact</h5>
          <p>{doctorDetails.contact || "N/A"}</p>
          <h5>About</h5>
          <p>{doctorDetails.about || "No description available."}</p>
        </Col>
      </Row>
    )}
    {!loading && !doctorDetails && <p className="text-center">Failed to load doctor details.</p>}
  </Modal.Body>
  <Modal.Footer>
    <Button variant="secondary" onClick={onHide}>
      Close
    </Button>
  </Modal.Footer>
</Modal>

  );
};

const DoctorsPortfolio = () => {
  const [doctors, setDoctors] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedDoctorId, setSelectedDoctorId] = useState(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    axios
      .get("https://ricgop.online/api/get-doctors.php")
      .then((res) => setDoctors(res.data))
      .catch(() => setDoctors([]));
  }, []);

  const filteredDoctors = doctors.filter((doc) =>
    doc.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleDoctorClick = (id) => {
    setSelectedDoctorId(id);
    setShowModal(true);
  };

  return (
    <Container className="my-5">
      <h2 className="text-white mb-4 text-center">Meet Our Doctors</h2>

      <InputGroup className="mb-4 mx-auto" style={{ maxWidth: "400px" }}>
        <FormControl
          placeholder="Search doctor by name..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </InputGroup>

      <Row>
        {filteredDoctors.length === 0 && <p className="text-white">No doctors found.</p>}
        {filteredDoctors.map((doctor) => (
          <Col key={doctor.id} xs={12} sm={6} md={4} lg={3} className="mb-4">
            <DoctorCard doctor={doctor} onClick={handleDoctorClick} />
          </Col>
        ))}
      </Row>

      <DoctorDetailsModal
        show={showModal}
        onHide={() => setShowModal(false)}
        doctorId={selectedDoctorId}
      />

      <style>{`
        body {
          background: #111827;
        }

        .modern-doctor-card-wrapper {
          perspective: 1000px;
        }

        .modern-doctor-card {
          background: rgba(255, 255, 255, 0.05);
          border-radius: 20px;
          padding: 1.5rem;
          text-align: center;
          border: 1px solid rgba(255, 255, 255, 0.08);
          box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);
          backdrop-filter: blur(20px);
          transition: all 0.4s ease;
        }

        .modern-doctor-card:hover {
          transform: translateY(-10px);
          box-shadow: 0 12px 40px rgba(0, 200, 255, 0.2);
          border-color: rgba(0, 200, 255, 0.4);
        }

        .doctor-avatar-wrapper {
          width: 110px;
          height: 110px;
          margin: 0 auto 15px;
          border-radius: 50%;
          padding: 4px;
          background: linear-gradient(135deg, #00c6ff, #0072ff);
        }

        .doctor-avatar-modern {
          width: 100%;
          height: 100%;
          border-radius: 50%;
          object-fit: cover;
          border: 4px solid white;
        }

        .doctor-info {
          color: #fff;
        }

        .doctor-name-modern {
          font-size: 1.2rem;
          font-weight: 700;
          margin-bottom: 5px;
          color: #ffffff;
        }

        .doctor-spec {
          font-size: 0.9rem;
          color: #cfe6ff;
          margin-bottom: 15px;
        }

        .doctor-btn {
          background: linear-gradient(135deg, #00c6ff, #0072ff);
          border: none;
          padding: 0.4rem 1.1rem;
          border-radius: 20px;
          color: #fff;
          font-weight: 500;
        }

        .doctor-btn:hover {
          background: linear-gradient(135deg, #0072ff, #00c6ff);
        }

      

        .doctor-modal-avatar {
          width: 160px;
          height: 160px;
          object-fit: cover;
          border: 5px solid #fff;
        }

        .gradient-btn {
          background: linear-gradient(to right, #00c6ff, #0072ff);
          border: none;
          color: white;
          border-radius: 30px;
          transition: background 0.3s;
        }

        .gradient-btn:hover {
          background: linear-gradient(to right, #0072ff, #00c6ff);
        }

        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
.glass-modal .modal-dialog {
  max-width: 600px;
  margin: auto;
  border-radius: 15px;
}

.glass-modal .modal-content {
  background: rgba(255, 255, 255, 0.95);
  border: none;
  border-radius: 20px;
  backdrop-filter: blur(15px);
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.2);
  padding: 20px;
}

.modal-header,
.modal-footer {
  border: none;
  background: transparent;
}

.modal-title {
  font-weight: 700;
  font-size: 1.5rem;
  color: #111;
}

.doctor-modal-avatar {
  width: 150px;
  height: 150px;
  object-fit: cover;
  border: 4px solid #0072ff;
  border-radius: 50%;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}

.modal-body h5 {
  font-size: 1.1rem;
  margin-top: 12px;
  color: #0072ff;
}

.modal-body p {
  font-size: 1rem;
  color: #333;
  margin-bottom: 8px;
}


      `}</style>
    </Container>
  );
};

export default DoctorsPortfolio;
